import React, { useMemo } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import type { NativeStackScreenProps } from '@react-navigation/native-stack';
import { AppCard } from '../../components/AppCard';
import { AppScreen } from '../../components/AppScreen';
import { ScreenHeader } from '../../components/ScreenHeader';
import { getAppInfo } from '../../config/appInfo';
import type { RootStackParamList } from '../../constants/routes';
import { spacing } from '../../constants/spacing';
import { typography } from '../../constants/typography';
import { useAppColors } from '../../context/PreferencesContext';

type Props = NativeStackScreenProps<RootStackParamList, 'About'>;

function Field({
  label,
  value,
  color,
  muted,
}: {
  label: string;
  value: string;
  color: string;
  muted: string;
}) {
  return (
    <>
      <Text style={[styles.label, { color: muted }]}>{label}</Text>
      <Text
        style={[styles.value, { color }]}
        accessibilityLabel={`${label}: ${value}`}
      >
        {value}
      </Text>
    </>
  );
}

export function AboutScreen({ navigation }: Props) {
  const palette = useAppColors();
  const info = useMemo(() => getAppInfo(), []);

  return (
    <AppScreen scroll>
      <ScreenHeader
        title="About"
        onBack={navigation.goBack}
      />
      <View style={styles.body}>
        <AppCard style={styles.card}>
          <Field
            label="App name"
            value={info.appName}
            color={palette.textPrimary}
            muted={palette.textMuted}
          />
          <Field
            label="Version"
            value={info.version}
            color={palette.textPrimary}
            muted={palette.textMuted}
          />
          <Field
            label="Build number"
            value={info.buildNumber}
            color={palette.textPrimary}
            muted={palette.textMuted}
          />
          <Field
            label="API version"
            value={info.apiVersion}
            color={palette.textPrimary}
            muted={palette.textMuted}
          />
          <Field
            label="Environment"
            value={info.environment}
            color={palette.textPrimary}
            muted={palette.textMuted}
          />
          <Field
            label="Platform"
            value={info.platform}
            color={palette.textPrimary}
            muted={palette.textMuted}
          />
        </AppCard>
      </View>
    </AppScreen>
  );
}

const styles = StyleSheet.create({
  body: { marginTop: spacing.lg },
  card: { gap: spacing.sm },
  label: { ...typography.caption, fontWeight: '600', marginTop: spacing.sm },
  value: { ...typography.body },
});
